import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Ansicht } from "../design/Ansicht";
import { Meldung } from "../design/Hinweis";
import { abrufadresse } from "./medien";

/**
 * Öffnen eines Mediums außerhalb der App (ADR-0024, medien.md §6): Ein Fingertipp auf „Dokument“, „Foto“ oder „Video“
 * öffnet sofort eine eigene Seite unter `/medien/kanaele/<KanalId>/nachrichten/<NachrichtId>/<Datei>`; sie holt mit der
 * Anmeldung des Geräts die kurzlebige Leseadresse und übergibt an den Systembetrachter. Die App bettet das Medium nie
 * selbst ein; die Leseadresse steht nie in einer Adresse der App.
 */
const ARTEN: Record<string, { name: string; symbol: string; teil: "medium" }> = {
  "medium.pdf": { name: "Dokument", symbol: "dokument", teil: "medium" },
  "medium.jpg": { name: "Foto", symbol: "foto", teil: "medium" },
  "medium.mp4": { name: "Video", symbol: "video", teil: "medium" },
};

export function mediumPfad(kanalId: string, nachrichtId: string, medienart: string): string | null {
  const datei = Object.entries(ARTEN).find(([, a]) => a.name === medienart)?.[0];
  return datei ? `/medien/kanaele/${encodeURIComponent(kanalId)}/nachrichten/${encodeURIComponent(nachrichtId)}/${datei}` : null;
}

export function MediumOeffnen() {
  const { kanalId = "", nachrichtId = "", datei = "" } = useParams();
  const art = ARTEN[datei];
  const [fehlt, setFehlt] = useState(false);
  useEffect(() => {
    if (!art) return;
    let aus = false;
    void abrufadresse(kanalId, nachrichtId, art.teil).then((url) => {
      if (aus) return;
      if (url) window.location.replace(url);
      else setFehlt(true);
    });
    return () => { aus = true; };
  }, [art, kanalId, nachrichtId]);
  return (
    <Ansicht name={art?.name ?? "Medium"} symbol={art?.symbol ?? "anhang"}>
      {!art || fehlt ? <Meldung symbol="abgewiesen">abgewiesen <span className="grund">kein-zugriff</span></Meldung> : null}
    </Ansicht>
  );
}
